module.exports = "<div class=\"carousel\">\n  <div class=\"carousel-inner\" ng-transclude></div>\n</div>\n";